<template>
  <template v-for="(menu, j) in theModel" :key="j">
    <div class="context-menu-container">
      <FormInput
        v-model="menu.label"
        title="Label"
        helpText="ชื่อที่จะแสดงบนเมนู"
        placeholder="Menu label"
        :onBlur="(e) => validateInput(e.target.value, `menuLabel${j}`)"
        :isShowErrorMessage="errors[`menuLabel${j}`]"
        :errorMessage="`Please put menu ${j+1} label`"
        class="w-40"
        isSubItem
        required
      />
      <FormCodeEditor
        v-model="menu.listener"
        title="Listener"
        helpText="ฟังก์ชันที่จะถูกเรียกเมื่อผู้ใช้เลือกแชร์ไปยังโซเชียลเน็ตเวิร์ค"
        :defaultCode="listenerDefaultCode"
        :onBlur="(e) => validateInput(e.target.value, `menuListener${j}`)"
        :isShowErrorMessage="errors[`menuListener${j}`]"
        :errorMessage="`Please put menu ${j+1} listener`"
        isSubItem
        required
      />
      <div class="remove-btn" @click="onRemoveMenu(j)">
        <svg
          width="10"
          height="12"
          viewBox="0 0 10 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.19998 10.2544C1.19998 10.5096 1.30007 10.7545 1.47823 10.935C1.65639 11.1155 1.89803 11.2169 2.14998 11.2169H7.84998C8.10194 11.2169 8.34358 11.1155 8.52174 10.935C8.69989 10.7545 8.79998 10.5096 8.79998 10.2544V3.51687H1.19998V10.2544ZM6.58332 5.12103C6.58332 5.03594 6.61668 4.95434 6.67607 4.89417C6.73545 4.834 6.816 4.8002 6.89998 4.8002C6.98397 4.8002 7.06451 4.834 7.1239 4.89417C7.18329 4.95434 7.21665 5.03594 7.21665 5.12103V9.6127C7.21665 9.69779 7.18329 9.77939 7.1239 9.83956C7.06451 9.89973 6.98397 9.93353 6.89998 9.93353C6.816 9.93353 6.73545 9.89973 6.67607 9.83956C6.61668 9.77939 6.58332 9.69779 6.58332 9.6127V5.12103ZM4.68332 5.12103C4.68332 5.03594 4.71668 4.95434 4.77607 4.89417C4.83545 4.834 4.916 4.8002 4.99998 4.8002C5.08397 4.8002 5.16451 4.834 5.2239 4.89417C5.28329 4.95434 5.31665 5.03594 5.31665 5.12103V9.6127C5.31665 9.69779 5.28329 9.77939 5.2239 9.83956C5.16451 9.89973 5.08397 9.93353 4.99998 9.93353C4.916 9.93353 4.83545 9.89973 4.77607 9.83956C4.71668 9.77939 4.68332 9.69779 4.68332 9.6127V5.12103ZM2.78332 5.12103C2.78332 5.03594 2.81668 4.95434 2.87607 4.89417C2.93545 4.834 3.016 4.8002 3.09998 4.8002C3.18397 4.8002 3.26451 4.834 3.3239 4.89417C3.38329 4.95434 3.41665 5.03594 3.41665 5.12103V9.6127C3.41665 9.69779 3.38329 9.77939 3.3239 9.83956C3.26451 9.89973 3.18397 9.93353 3.09998 9.93353C3.016 9.93353 2.93545 9.89973 2.87607 9.83956C2.81668 9.77939 2.78332 9.69779 2.78332 9.6127V5.12103ZM9.11665 1.59187H6.74165L6.55561 1.21689C6.5162 1.13673 6.45549 1.06929 6.38032 1.02218C6.30514 0.975062 6.21848 0.950135 6.13009 0.950199H3.8679C3.7797 0.949855 3.6932 0.97469 3.61829 1.02186C3.54338 1.06903 3.4831 1.13662 3.44436 1.21689L3.25832 1.59187H0.883317C0.799332 1.59187 0.718786 1.62567 0.6594 1.68584C0.600013 1.746 0.56665 1.82761 0.56665 1.9127L0.56665 2.55437C0.56665 2.63946 0.600013 2.72106 0.6594 2.78123C0.718786 2.8414 0.799332 2.8752 0.883317 2.8752H9.11665C9.20064 2.8752 9.28118 2.8414 9.34057 2.78123C9.39995 2.72106 9.43332 2.63946 9.43332 2.55437V1.9127C9.43332 1.82761 9.39995 1.746 9.34057 1.68584C9.28118 1.62567 9.20064 1.59187 9.11665 1.59187Z"
            fill="#EB5757"
          />
        </svg>
        <p>Remove</p>
      </div>
    </div>
  </template>
  <button type="button" class="add-btn" @click="onNewMenu">
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.29995 4.03457H6.14995V0.88457C6.14995 0.498039 5.83648 0.18457 5.44995 0.18457H4.74995C4.36342 0.18457 4.04995 0.498039 4.04995 0.88457V4.03457H0.899951C0.51342 4.03457 0.199951 4.34804 0.199951 4.73457V5.43457C0.199951 5.8211 0.51342 6.13457 0.899951 6.13457H4.04995V9.28457C4.04995 9.6711 4.36342 9.98457 4.74995 9.98457H5.44995C5.83648 9.98457 6.14995 9.6711 6.14995 9.28457V6.13457H9.29995C9.68648 6.13457 9.99995 5.8211 9.99995 5.43457V4.73457C9.99995 4.34804 9.68648 4.03457 9.29995 4.03457Z"
        fill="#9EA4A9"
      />
    </svg>
    {{ title }}
  </button>
</template>

<script>
import { computed } from "vue";
import FormInput from "./FormInput.vue";
import FormCodeEditor from "./FormCodeEditor.vue";
import useFormValidation from "../../utils/useFormValidation";
export default {
  setup(props, { emit }) {
    const theModel = computed({
      // Use computed to wrap the object
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });
    const { validateNameField, errors } = useFormValidation();
    return { theModel, validateNameField, errors };
  },
  components: {
    FormInput,
    FormCodeEditor,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],
  data () {
    return {
      listenerDefaultCode: "function() { \n\talert('Hello, world! menu item is clicked');\n}"
    }
  },
  methods: {
    onNewMenu() {
      this.theModel.push({ label: "", listener: "" });
    },
    onRemoveMenu(index) {
      this.theModel = this.theModel.filter((any, i) => i !== index);
      this.errors[`menuListener${index}`] = false
      this.errors[`menuLabel${index}`] = false
    },
    validateInput(val, name) {
      this.validateNameField(name, val);
    },
  },
};
</script>

<style lang="scss" scoped>
.context-menu-container {
  background-color: $white;
  padding: $space $space + 8px;
  display: flex;
  flex-direction: column;
  row-gap: $space / 2;
  position: relative;
  margin: 0 0 $space + 8px 0;
}
.add-btn {
  border: 0;
  background: 0;
  color: $grey-700;
  font-weight: 400;
  display: flex;
  column-gap: $space - 9px;
  align-items: center;
  cursor: pointer;
}
.remove-btn {
  position: absolute;
  display: flex;
  color: $danger;
  fill: $danger;
  align-items: center;
  top: $space + 6px;
  right: $space + 8px;
  column-gap: 6.57px;
  cursor: pointer;
  font-size: $base-font-size;
  font-weight: 500;
}
.w-40{
  width: 40%;
}
</style>
